import { CalendarDays, InfoIcon, LucideIcon, PlusCircleIcon, SearchIcon } from "lucide-react";
import { useMemo } from "react";

import resultAsset from "@/assets/result/resultAsset.svg";

import {
  assetIconPositionVariants,
  assetIconVariants,
  assetVariants,
  ResultVariantsProps,
} from "./Result.styles";

type ResultIconProps = ResultVariantsProps & {
  readonly icon: React.ReactNode;
  readonly status?: "success" | "error" | "normal";
};

export function ResultIcon({ size, icon, status = "normal" }: ResultIconProps) {
  return <div className={assetIconVariants({ size, status })}>{icon}</div>;
}

export type ResultAssetProps = ResultVariantsProps & {
  status?: ResultIconProps["status"];
  icon?: "search" | "calendar-days" | "info" | "plus-circle" | React.ReactElement;
};

export function ResultAsset({ size, status, icon }: Readonly<ResultAssetProps>) {
  const iconResult: React.ReactNode = useMemo(() => {
    if (typeof icon !== "string") {
      return icon;
    }

    const mapper: { [key: string]: LucideIcon } = {
      "calendar-days": CalendarDays,
      search: SearchIcon,
      info: InfoIcon,
      "plus-circle": PlusCircleIcon,
    };

    if (typeof icon === "undefined" || !(icon in mapper)) {
      return <></>;
    }

    const Icon: LucideIcon | undefined = mapper[icon];
    return <Icon size={size === "sm" ? 18 : 24} strokeWidth={2} />;
  }, [icon, size]);

  return (
    <div className="relative">
      <img
        alt="Ilustración figurativa asociada a información de resultado"
        className={assetVariants({ size })}
        src={resultAsset}
      />
      <div className={assetIconPositionVariants({ size })}>
        <ResultIcon icon={iconResult} size={size} status={status} />
      </div>
    </div>
  );
}
